import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ValoracionFuncionalTable from '../components/ValoracionFuncionalTable';

export default function ValoracionFuncionalListPage() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <ValoracionFuncionalTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
